export default "__VITE_ASSET__zyjHEQkI__"